import PropTypes from 'prop-types';
import { getSelectionText } from '../common';
import { DeliveryOptionsSelectedTextStyle } from './DeliveryOptionsSelectedText.style';

function DeliveryOptionsSelectedText({ textData, labelsData, labelsKey }) {
  if (!textData) {
    return null;
  }

  const {
    isError,
    deliverOptionText,
    location,
    greenText,
    normalText,
    isHomeDelivery,
    isStockInStore,
    locationName,
    parentStateName,
    storeName,
    textUnits,
    classUnits,
    operatorIcon,
  } = textData;

  if (isError) {
    return (
      <div className="delivery-option-selection-container">
        <p className="delivery-option-selection not-found">
          <span>{deliverOptionText}</span>
        </p>
        <p className="delivery-option-selection locationName">{location}</p>
        <style jsx>{DeliveryOptionsSelectedTextStyle}</style>
      </div>
    );
  }
  return (
    <>
      <div className="delivery-option-selection-container">
        <p className="delivery-option-selection">
          <span className="bold green">{greenText}</span>
          <span>
            {greenText ? ' ' : ''} {normalText}
          </span>
        </p>
        <div className="delivery-option-locationName">
          {isHomeDelivery ? (
            <p className="do-locationName">
              {locationName}, {parentStateName}
            </p>
          ) : (
            <div className="delivery-option-selected-store-info">
              {isStockInStore && <span className={`icon ${operatorIcon} hide-in-mobile`} />}
              <div className="do-info">
                <p className="do-locationName">{storeName}</p>
                <p className={`store-availability ${classUnits}`}>{textUnits}</p>
              </div>
            </div>
          )}
        </div>
        <style jsx>{DeliveryOptionsSelectedTextStyle}</style>
      </div>
      <span>
        {getSelectionText({
          labelsData,
          labelsKey,
          persistedText: textData,
        })}
      </span>
    </>
  );
}

DeliveryOptionsSelectedText.propTypes = {
  textData: PropTypes.shape({
    isError: PropTypes.bool,
    deliverOptionText: PropTypes.string,
    location: PropTypes.string,
    greenText: PropTypes.string,
    normalText: PropTypes.string,
    isHomeDelivery: PropTypes.bool,
    isStockInStore: PropTypes.bool,
    locationName: PropTypes.string,
    parentStateName: PropTypes.string,
    storeName: PropTypes.string,
    textUnits: PropTypes.string,
    classUnits: PropTypes.string,
    operatorIcon: PropTypes.string,
  }),
  labelsData: PropTypes.object.isRequired,
  labelsKey: PropTypes.object.isRequired,
};

DeliveryOptionsSelectedText.defaultProps = {
  textData: null,
};

export default DeliveryOptionsSelectedText;
